import { Injectable } from '@angular/core';

export interface RingtoneConfig {
  enabled: boolean;
  volume: number;
  customUrl: string | null;
  timeoutSeconds: number;
}

const DEFAULTS: RingtoneConfig = {
  enabled: true,
  volume: 0.7,
  customUrl: null,
  timeoutSeconds: 30,
};

@Injectable({ providedIn: 'root' })
export class RingtoneConfigService {

  getConfig(): RingtoneConfig {
    try {
      const raw = localStorage.getItem('companyData');
      if (!raw) return { ...DEFAULTS };

      const company = JSON.parse(raw);
      const cc = company?.CallConfiguration;
      if (!cc) return { ...DEFAULTS };

      return {
        enabled: cc.ringtone_enabled ?? DEFAULTS.enabled,
        volume: cc.ringtone_volume ?? DEFAULTS.volume,
        customUrl: cc.incoming_call_ringtone_url || null,
        timeoutSeconds: cc.custom_ringtone_timeout ?? DEFAULTS.timeoutSeconds,
      };
    } catch {
      return { ...DEFAULTS };
    }
  }
}
